export function isUserLoggedIn(state) {
    return state.user.isLoggedIn;
}
export function getUserInfo(state){
    return state.user;
}